import { fetchOptions } from './csrf'

export interface WarrantyTranslation {
  id?: string
  language: 'english' | 'spanish'
  content: string
  _destroy?: boolean
}

export interface Warranty {
  id: string
  name: string
  is_default: boolean
  warranty_type: 'no_warranty' | 'full' | 'limited'
  labor_percentage: number
  parts_percentage: number
  created_at: string
  updated_at: string
  translations: WarrantyTranslation[]
}

interface WarrantiesResponse {
  warranties: Warranty[]
}

interface WarrantyResponse {
  warranty: Warranty
}

interface ErrorResponse {
  errors: string[]
}

export interface WarrantyParams {
  name: string
  is_default?: boolean
  warranty_type: string
  labor_percentage: number
  parts_percentage: number
  warranty_translations_attributes: WarrantyTranslation[]
}

export const warrantiesApi = {
  async list(): Promise<Warranty[]> {
    const response = await fetch('/api/v1/settings/warranties', fetchOptions())
    if (!response.ok) throw new Error('Failed to load warranties')
    const data: WarrantiesResponse = await response.json()
    return data.warranties
  },

  async create(params: WarrantyParams): Promise<Warranty> {
    const response = await fetch('/api/v1/settings/warranties', {
      ...fetchOptions('POST'),
      body: JSON.stringify({ warranty: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to create warranty'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: WarrantyResponse = await response.json()
    return data.warranty
  },

  async update(id: string, params: Partial<WarrantyParams>): Promise<Warranty> {
    const response = await fetch(`/api/v1/settings/warranties/${id}`, {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ warranty: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update warranty'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: WarrantyResponse = await response.json()
    return data.warranty
  },

  async destroy(id: string): Promise<void> {
    const response = await fetch(`/api/v1/settings/warranties/${id}`, fetchOptions('DELETE'))
    if (!response.ok) throw new Error('Failed to delete warranty')
  },
}
